import { setChainId } from '@/utils/auth.js'

const TARGET_CHAIN_ID = process.env.VUE_APP_CHAINID || ''
const TARGET_CHAIN_ID_NORMALIZED = TARGET_CHAIN_ID.toLowerCase()

function normalizeRpcUrl(url) {
  if (typeof url !== 'string') {
    return ''
  }

  const trimmed = url.trim()
  if (!trimmed) {
    return ''
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed
  }

  return trimmed
}

export function getEthereumProvider() {
  if (typeof window === 'undefined') {
    return undefined
  }

  const { ethereum } = window
  return ethereum && ethereum.isMetaMask ? ethereum : undefined
}

export function getTreasureNetworkConfig() {
  const rawRpcUrls = process.env.VUE_APP_RPC_URLS
  let rpcUrls = []

  try {
    const parsed = JSON.parse(rawRpcUrls)
    rpcUrls = Array.isArray(parsed) ? parsed : [parsed]
  } catch (error) {
    rpcUrls = [rawRpcUrls]
  }

  return {
    chainId: process.env.VUE_APP_CHAINID,
    chainName: process.env.VUE_APP_CHAIN_NAME,
    rpcUrls: rpcUrls.map(normalizeRpcUrl).filter(Boolean),
    blockExplorerUrls: ['https://scan.treasurenet.io/'],
    nativeCurrency: {
      name: 'UNIT',
      symbol: 'UNIT',
      decimals: 18
    }
  }
}

export function isExpectedChain(chainId) {
  return Boolean(chainId) && chainId.toLowerCase() === TARGET_CHAIN_ID_NORMALIZED
}

export async function getCurrentChainId(provider = getEthereumProvider()) {
  if (!provider) {
    return ''
  }

  return provider.request({ method: 'eth_chainId' })
}

export async function ensureTreasureNetwork(provider = getEthereumProvider()) {
  if (!provider) {
    const error = new Error('MetaMask is not installed')
    error.code = 'METAMASK_NOT_INSTALLED'
    throw error
  }

  try {
    await provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: process.env.VUE_APP_CHAINID }]
    })
    return 'switched'
  } catch (switchError) {
    if (![4902, -32602, -32603].includes(switchError.code)) {
      throw switchError
    }
  }

  await provider.request({
    method: 'wallet_addEthereumChain',
    params: [getTreasureNetworkConfig()]
  })
  return 'added'
}

export function getNetworkErrorMessage(error) {
  if (!error) {
    return 'Network configuration failed, please check MetaMask settings'
  }

  switch (error.code) {
    case 'METAMASK_NOT_INSTALLED':
      return 'Please install MetaMask first'
    case 4001:
      return 'User rejected the network request'
    case -32602:
      return 'Network configuration conflict, please delete the existing network in MetaMask and try again'
    case -32603:
      return 'Network connection failed, please check network settings or try again later'
    default:
      return 'Network switching failed, please check MetaMask settings'
  }
}

export function syncChainState(chainId, commit) {
  setChainId(chainId)
  if (typeof commit === 'function') {
    commit('app/SET_MATEMASK', { chainId })
  }
}
